import React from "react";
import Logo from "assets/icons/logoSubscriptionModal.png";
import CrossIcon from "assets/icons/cross.svg";
import "./styleModalCancel.scss";

interface Props {
  visible?: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
}

const ModalCancelSubscription = ({ visible, onClose, onConfirm }: Props) => {
  return (
    <>
      {visible && <div className="mobile-bacground-close" onClick={onClose}></div>}
      {visible && (
        <div className="modal-cancel-wrapper">
          <div className="fon-cancel-modal-mobile"></div>
          <div className="fon-cancel-modal">
            <div
              className="cross-container-cancel-modal"
              onClick={onClose}
              style={{ cursor: "pointer" }}>
              <img src={CrossIcon} style={{ width: 16, height: 16 }} />
            </div>
            <div className="line-top-modal-container">
              <div className="line-top-modal"></div>
            </div>
            <div className="inner-content-cancel-modal">
              <div style={{ marginBottom: 30 }}>
                <img src={Logo} style={{ width: 289, height: 287 }} />
              </div>
              <span>האם אתם בטוחים שברצונכם</span>
              <span>לבטל את החיוב האוטומטי?</span>
              <div className="SubscriptionDetailsTab-action">
                <input
                  className="save-changes-btn"
                  type="submit"
                  name="submit"
                  value="לא"
                  style={{
                    backgroundColor: "transparent",
                    border: "2px solid #fff",
                    marginLeft: 30,
                    width: 230
                  }}
                  onClick={onClose}
                />
                <input
                  className="save-changes-btn"
                  type="submit"
                  name="submit"
                  value="כן, לבטל"
                  onClick={onConfirm}
                  style={{ border: "2px solid #ff6360", backgroundColor: "#ff6360", width: 230 }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ModalCancelSubscription;
